import { Grid, Tooltip, styled } from "@mui/material";
import StringFormField from "./form-fields/String";
import DateFormField from "./form-fields/Date";
import MultichoiceFormField from "./form-fields/Multichoice";
import ObjectIdFormField from "./form-fields/ObjectId";
import NumberFormField from "./form-fields/Number";
import PhoneFormField from "./form-fields/Phone";
import BooleanFormField from "./form-fields/Boolean";
import { TooltipWrapperProps, RenderFormFieldProps } from "./types";
import { toGridItemProps } from "./grid-props";

export const TooltipSpan = styled("span")(() => ({
  width: "100%",
  height: "calc(100% - 15px)",
  display: "block",
}));

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ children, useTooltip, ...props }) => {
  if (!useTooltip) return <>{children}</>;

  return (
    <Tooltip arrow {...props}>
      <TooltipSpan>{children}</TooltipSpan>
    </Tooltip>
  );
};

export const RenderFormField = ({ field, hasAddPermission, keyIndex }: RenderFormFieldProps) => {
  if (field.hide) return null;

  if (field.type !== "custom") {
    field.disabled = hasAddPermission ? field.disabled : true;
  }

  if ("addButton" in field && field.addButton?.props) {
    field.addButton.props.disabled = hasAddPermission ? field.addButton.props.disabled : true;
  }

  return (
    <Grid key={`form-field-${keyIndex}`} {...toGridItemProps(field.gridProps)}>
      <TooltipWrapper useTooltip={!!field.tooltipMessage} title={field.tooltipMessage}>
        <>
          {field.type === "string" && <StringFormField {...field} />}
          {field.type === "date" && <DateFormField {...field} />}
          {field.type === "multichoice" && <MultichoiceFormField {...field} />}
          {field.type === "ObjectId" && <ObjectIdFormField {...field} />}
          {field.type === "number" && <NumberFormField {...field} />}
          {field.type === "phone" && <PhoneFormField {...field} />}
          {field.type === "boolean" && <BooleanFormField {...field} />}
          {field.type === "custom" && field.component}
        </>
      </TooltipWrapper>
    </Grid>
  );
};
